<template>
  <div class="add-new-payment-method">

    <div class="add-new-payment-method-controls">
    <a
      class="add-new-payment-method-link"
      href="#"
      :class="{'' : showLargePrompt}"
      v-if="!showForm"
      @click="showFormHandler"
    >
      Add New Payment Method
    </a>
    </div>

    <form
      id="add-new-payment-method-form"
      @submit.prevent="paymentMethodHandler"
      v-show="showForm"
    >
      <NameOnCard
        @name="updateName"
        :error="nameError"
        @disable-error="disableError"
      />
      <div id="card-element" class="card-only"></div>

      <div class="buttons">

        <a class="button expand" href="#" @click="hideForm">
            <span>Cancel</span>
        </a>

        <button class="button expand" type="submit" style="background-color: #57b9ac">
            <span>Save</span>
        </button>
      </div>


      <PaymentError :error="displayError" />
    </form>
  </div>
</template>

<script>
import {
  instantiateStripePlatform,
  attachPaymentMethod,
} from '../stripe-elements';
import PaymentError from '../PaymentError.vue';
import PaymentsMixin from '../PaymentsMixin.vue';
import NameOnCard from '../NameOnCard.vue';

export default {
  name: 'SCACreateSubscriptionCardForm',
  mixins: [PaymentsMixin],
  components: {
    NameOnCard,
    PaymentError,
  },
  data() {
    return {
      showForm: false,
      displayError: '',
      disabled: true,
      nameOnCard: '',
      nameError: false,
      stripe: {},
      elements: {},
      card: {},
      style: {
        width: '500px',
        base: {
          color: 'primary',
          fontWeight: 500,
          fontFamily: 'Inter UI, Open Sans, Segoe UI, sans-serif',
          fontSize: '16px',
          fontSmoothing: 'antialiased',

          '::placeholder': {
            color: 'primary',
          },
        },
        invalid: {
          color: 'alert',
        },
      },
    };
  },
  props: {
    stripePublicKey: {
      type: String,
      required: true,
    },
    paymentMethods: {
      type: Array,
      required: true,
    },
  },
  computed: {
    showLargePrompt() {
      return this.paymentMethods.length > 0;
    },
  },
  methods: {
    async paymentMethodHandler() {

      if (this.nameOnCard.length === 0) {
        this.displayError = 'Please fill in the Name on card';
        this.nameError = true;
        return;
      }

      if(this.disabled) {
        return;
      }

      this.nameError = false;
      this.displayError = '';


      await this.createPaymentMethodOnPlatform();
      this.$emit('show-form', false);
      this.showForm = false;
    },
    showFormHandler(){
        this.showForm = true;
        this.$emit('show-form', true);

    },
    hideForm(event) {
        event.preventDefault();
        this.showForm = false;
        this.nameOnCard = '';
        this.$emit('show-form', false);
    },
    mountCardForm() {
      const { style } = this;
      this.card = this.elements.create('card', {
        hidePostalCode: true,
        style,
      });
      this.card.mount('#card-element');

      this.card.on('change', (event) => {
        this.errorCall(event);
      });
    },
    errorCall(event) {
      event.error
        ? (this.displayError = event.error.message)
        : (this.displayError = '');
      event.complete ? (this.disabled = false) : (this.disabled = true);
      this.disabled && event.error
        ? (this.displayError = event.error.message)
        : (this.displayError = '');
    },

    async createPaymentMethodOnPlatform() {
      if (this.disabled === false) {
        this.$emit('emit-global-loading', true);
      }

      const { paymentMethod } = await this.createPaymentMethod(this.nameOnCard);
      const { data, status } = await attachPaymentMethod(paymentMethod.id);
      this.$emit('payment-method-created', data);
      this.nameOnCard = '';
    },
    async createPaymentMethod(name) {
    const {card} = this;
      return this.stripe.createPaymentMethod({
        type: 'card',
        card,
        billing_details: {
          name,
        },
      });
    },
  },

  async beforeMount() {},
  mounted() {
    const { stripePublicKey } = this;
    const { stripe, elements } = instantiateStripePlatform(Stripe, {
      stripePublicKey,
    });
    this.stripe = stripe;
    this.elements = elements;
    this.mountCardForm();
  },
};
</script>

<style lang="scss" scoped>
form > * + * {
  margin-top: 20px;
}

input {
  border: 0px solid;
}

.buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 15%;
}

.add-new-payment-method {
    margin-bottom: 16px;
}

.add-new-payment-method-controls{
    display: grid;
    text-align: center;
    padding: 4px;


}

.add-new-payment-method-link {
    color: #03b5da;
    text-align: center;
    font-size: 0.9rem;
}
</style>
